import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './FetchBaseQuery';

export const addonServiceApi = createApi({
   reducerPath: 'addonServiceApi',
   baseQuery: baseQueryWithReauth,
   tagTypes: ['AddonService'],
   endpoints: (builder) => ({
      getAddonServices: builder.query({
         query: ({ limit = 10, page = 1, search = '' }) => {
            const params = new URLSearchParams();
            params.append('limit', limit);
            params.append('page', page);
            if (search) params.append('search', search);
            return {
               url: `/addon/list?${params.toString()}`,
               method: 'GET',
            };
         },
         providesTags: ['AddonService'],
      }),

      getAddonServiceById: builder.query({
         query: (id) => ({
            url: `/addon/view/${id}`,
            method: 'GET',
         }),
         providesTags: ['AddonService'],
      }),

      createAddonService: builder.mutation({
         query: (req) => ({
            url: `/addon/create`,
            method: 'POST',
            body: req,
         }),
         invalidatesTags: ['AddonService'],
      }),

      updateAddonService: builder.mutation({
         query: ({ id, ...data }) => ({
            url: `/addon/update/${id}`,
            method: 'PUT',
            body: data,
         }),
         invalidatesTags: ['AddonService'],
      }),

      deleteAddonService: builder.mutation({
         query: (id) => ({
            url: `/addon/delete/${id}`,
            method: 'DELETE',
         }),
         invalidatesTags: ['AddonService'],
      }),

      // Quotation Add-on endpoints
      addQuotationAddons: builder.mutation({
         query: ({ quotationId, addons }) => ({
            url: `/quotation/${quotationId}/addons`,
            method: 'POST',
            body: { quotationAddons: addons },
         }),
      }),

      getQuotationAddons: builder.query({
         query: (quotationId) => ({
            url: `/quotation/${quotationId}/addons`,
            method: 'GET',
         }),
      }),

      deleteQuotationAddon: builder.mutation({
         query: ({ quotationId, qaId }) => ({
            url: `/quotation/${quotationId}/addons/${qaId}`,
            method: 'DELETE',
         }),
      }),

      deleteAllQuotationAddons: builder.mutation({
         query: (quotationId) => ({
            url: `/quotation/${quotationId}/addons`,
            method: 'DELETE',
         }),
      }),

      getClientAddons: builder.query({
         query: (quotationId) => ({
            url: `/quotation/${quotationId}/client-addons`,
            method: 'GET',
         }),
      }),
   }),
});

export const {
   useGetAddonServicesQuery,
   useGetAddonServiceByIdQuery,
   useCreateAddonServiceMutation,
   useUpdateAddonServiceMutation,
   useDeleteAddonServiceMutation,
   useAddQuotationAddonsMutation,
   useGetQuotationAddonsQuery,
   useDeleteQuotationAddonMutation,
   useDeleteAllQuotationAddonsMutation,
   useGetClientAddonsQuery,
} = addonServiceApi;
